import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'

import AudioImport from '../components/AppAudioImport.vue'

class AudioImportController extends Controller<HTMLButtonElement> {
  static values = {
    apiBase: String,
    reportId: Number,
    initialStartTime: String,
    initialEndTime: String,
  }

  declare readonly apiBaseValue: string
  declare readonly reportIdValue: number
  declare readonly initialStartTimeValue: string
  declare readonly initialEndTimeValue: string

  _container?: HTMLDivElement
  _app?: ReturnType<typeof createApp>

  async connect() {
    const container = document.createElement('div')
    document.body.insertAdjacentElement('afterend', container)
    this._container = container
    this._app = createApp(AudioImport, {
      apiBase: this.apiBaseValue,
      reportId: this.reportIdValue,
      start: this.initialStartTimeValue,
      end: this.initialEndTimeValue,
    })
    this._app.mount(container)
  }

  disconnect() {
    if (this._app) {
      this._app.unmount()
    }
    if (this._container) {
      this._container.remove()
    }
  }

  openDialog() {
    // @ts-expect-error There must be a better solution to call this method.
    this._app?._instance?.setupState?.openDialog?.()
  }
}

export default AudioImportController
